import React from 'react';
import { remoteAccessDialogTitles } from '../../RemoteAccessDialogConstants';

function Header() {
  return (
    <div className="remote-access-dialog__header">
      <h3>{remoteAccessDialogTitles.CHOICE}</h3>
    </div>
  );
}

export default Header;
